import { CUSTOM_ICON_REGISTRY } from "./customIcons";
import type { IconName } from "./Icon";
import { phosphorNames } from "./phosphorNames.generated";

const names = new Set<string>([...phosphorNames, ...Object.keys(CUSTOM_ICON_REGISTRY)]);
export function isIconName(name: string): name is IconName {
  return names.has(name);
}
